import { Box } from '../../Box/Box.js';
import styled from 'styled-components';

var CheckboxStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Checkboxstyled__CheckboxStyled",
  componentId: "sc-1melmzp-0"
})({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute'
});

export { CheckboxStyled };
//# sourceMappingURL=Checkbox.styled.js.map
